import React, { Component } from 'react';
import { Modal, Calendar } from "antd";


class ModalCalender extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isPanelChange: false,
      selectedDate: props.date
    };

  }

  onPanelChange = (value, mode) => {
  };

  onSelect = (value) => {
    this.setState({ selectedDate: value })
  };

  handleOk = () => {

    const { onSelect } = this.props;
    onSelect(this.state.selectedDate)
  };

  render() {

    const { isModalOpen, handleCancel, createOptions } = this.props;
    const { selectedDate } = this.state;

    return (
      <Modal title="Takvim" centered open={isModalOpen} onOk={this.handleOk} onCancel={handleCancel} maskClosable={false}>
        <Calendar fullscreen={false} onChange={this.onSelect} onPanelChange={this.onPanelChange} mode={"month"} defaultValue={selectedDate} 
         disabledDate={d => !d || d.isBefore(createOptions.minDepartureDate)} 
        />
      </Modal>
    )
  }
}
export default ModalCalender;


// WEBPACK FOOTER //
// ./src/components/App/components/ModalCalender.js